import api from "@/api";
import { paths } from "@/router";

const url = new URL(location.href);
const searchParams = url.searchParams;

const state = {
  deviceName: {
    dr001: "Black Diamond 75",
    cb_matrix: "CYBERBOARD MATRIX",
    "65les": "AM 65 LESS",
    hatsu: "HATSU",
    am21: "AM Relic 80",
    cb_terminal: "CYBERBOARD Terminal",
    cb03: "CYBERBOARD_II",
    cb03_r5: "CYBERBOARD R5",
    cb04: "CYBERBOARD",
    cb02: "LE SMOKING",
    alice: "AM AFA",
    cyberblade: "CYBERBLADE",
    dongle: "AngryMiao dongle",
    am_28: "AM RGB 65",
    "65les_r2": "AM 65 LESS R2",
    "65les_r1": "AM 65 LESS R1",
    dr002: "PETBRICK 65",
    dr002_2: "Mecha 65",
    mouse: "AM INFINITY .100",
    mousedongle: "AM INFINITY .100",
    am35: "AM Infinity .97",
    am35_d: "AM Infinity .97",
    MOUSE: "Angrymiao Mouse",
    DR001: "Black Diamond 75",
    CB_MATRIX: "CYBERBOARD MATRIX",
    "65LES": "AM 65 LESS",
    HATSU: "HATSU",
    AM21: "AM Relic 80",
    CB_TERMINAL: "CYBERBOARD Terminal",
    CB03: "CYBERBOARD_II",
    CB03_R5: "CYBERBOARD R5",
    CB04: "CYBERBOARD",
    CB02: "LE SMOKING",
    ALICE: "AM AFA",
    CYBERBLADE: "CYBERBLADE",
    DONGLE: "AngryMiao dongle",
    AM_28: "AM RGB 65",
    "65LES_R2": "AM 65 LESS R2",
    "65LES_R1": "AM 65 LESS R1",
    DR002: "PETBRICK 65",
    MOUSE: "AM INFINITY .100",
    MOUSEDONGLE: "AM INFINITY .100",
    AM35: "AM Infinity .97",
  },
  loading: false,
  inLoader: searchParams.get("inLoader") === "true" || !!window.qt,
  isQT: !!window.qt,
  isWeb:false,
  bridge: null,
  systemInfo: {
    deviceList: [],
    version: "",
    isLatestVersion: true,
    updateDescription: {
      zh_CN: "",
      en_US: "",
    },
    password: "135qwr",
    language: "",
  },
  currentDevice: {
    port: "",
    code: "",
    updateDescription: { zh_CN: "", en_US: "" },
  },
  activeDeviceIndex: 0,
};

let timer = 0;

const actions = {
  setLoading({ commit }, data) {
    let loading;
    let time = 7000;
    if (typeof data === "boolean") {
      loading = data;
    } else {
      loading = data.loading;
      time = data.time;
    }
    if (loading) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        commit("SET_LOADING", false);
      }, time);
    }
    commit("SET_LOADING", loading);
  },
  setInLoader({ commit }, inLoader) {
    commit("SET_IN_LOADER", inLoader);
  },
  setBridge({ commit }, bridge) {
    commit("SET_BRIDGE", bridge);
  },
  aiChat(context, data) {
    return api.chat(data);
  },
  setIsWeb({ commit }, data) {
    commit("SET_IS_WEB", data);
  },
  setDeviceName({ commit }, deviceName) {
    for (const key in deviceName) {
      deviceName[key.toLowerCase()] = deviceName[key];
    }
    // 统一前端展示名，避免被运行时下发的旧型号名称覆盖。
    deviceName.mouse = "AM INFINITY .100";
    deviceName.mousedongle = "AM INFINITY .100";
    deviceName.MOUSE = "AM INFINITY .100";
    deviceName.MOUSEDONGLE = "AM INFINITY .100";
    commit("SET_DEVICE_NAME", deviceName);
  },
  setSystemInfo({ commit, dispatch }, systemInfo) {
    // 防止 password 为空的情况
    if (!systemInfo.password) {
      systemInfo.password = "135qwr";
    }
    systemInfo.deviceList = systemInfo.deviceList.map((device) => ({
      ...device,
      code: device.code.toLowerCase(),
    }));
    commit("SET_LOADER_INFO", systemInfo);
    dispatch("app/setLanguage", systemInfo.language, { root: true });
  },
  getSystemInfo({ state }) {
    console.log("Bridge", "getSystemInfo");
    if (!state.bridge) return;
    state.bridge.getSystemInfo();
  },
  getDongle({ state }, json) {
    console.log("Bridge", "getDongle", json);
    if (!state.bridge) return;
    state.bridge.getDongle(JSON.stringify(json));
  },
  updateDongle({ state }, json) {
    console.log("Bridge", "updateDongle", json);
    if (!state.bridge) return;
    state.bridge.updateDongle(JSON.stringify(json));
  },
  pairDongle({ state }, json) {
    console.log("Bridge", "pairDongle", json);
    if (!state.bridge) return;
    state.bridge.pairDongle(JSON.stringify(json));
  },
  openCommunity({ state }) {
    console.log("Bridge", "openCommunity");
    if (!state.bridge) return;
    state.bridge.openCommunity();
  },
  setLanguage({ state }, language) {
    console.log("Bridge", "setLanguage", language);
    if (!state.bridge) return;
    state.bridge.setLanguage(language);
  },
  setCurrentDevice({ commit, state }, device) {
    device = {
      ...device,
      code: device.code.toLowerCase(),
    };
    commit("SET_CURRENT_DEVICE", device);
    console.log("Bridge", "setCurrentDevice", device);
    if (!state.bridge) return;
    state.bridge.setCurrentDevice(JSON.stringify(device));
  },
  setActiveDeviceIndex({ commit }, index) {
    commit("SET_ACTIVE_DEVICE_INDEX", index);
  },
  updateLoader({ state }) {
    console.log("Bridge", "updateLoader");
    if (!state.bridge) return;
    state.bridge.updateLoader();
  },
  restartLoader({ state }) {
    console.log("Bridge", "restartLoader");
    if (!state.bridge) return;
    state.bridge.restartLoader();
  },
  updateFirmware({ state }) {
    console.log("Bridge", "updateFirmware");
    if (!state.bridge) return;
    state.bridge.updateFirmware();
  },
  loadFirmware({ state }) {
    console.log("Bridge", "loadFirmware");
    if (!state.bridge) return;
    state.bridge.loadFirmware();
  },
  loadJson({ state }) {
    console.log("Bridge", "loadJson");
    if (!state.bridge) return;
    state.bridge.loadJson();
  },
  downloadJSON({ state }, json) {
    console.log("Bridge", "downloadJSON", "End", json);
    if (!state.bridge) return;
    state.bridge.downloadJSON(JSON.stringify(json));
  },
  syncMacroKey({ state, commit }, json) {
    console.log("Bridge", "syncMacroKey", json);
    if (!state.bridge) return;
    state.bridge.syncMacroKey(JSON.stringify(json));
    commit("SET_LOADING", true);
  },
  syncJSON({ state }) {
    console.log("Bridge", "syncJSON");
    if (!state.bridge) return;
    state.bridge.syncJSON();
  },
  resetJSON({ state }) {
    console.log("Bridge", "resetJSON");
    if (!state.bridge) return;
    state.bridge.resetJSON("reset");
  },
  downloadFile({ state }, json) {
    console.log("Bridge", "downloadFile", json);
    if (!state.bridge) return;
    state.bridge.downloadFile(JSON.stringify(json));
  },
  transportMode({ state }) {
    console.log("Bridge", "transportMode");
    if (!state.bridge) return;
    state.bridge.transport_mode();
  },

  // AM INFINITY .100
  initMouseData({ state }) {
    console.log("Bridge", "initMouseData");
    if (!state.bridge) {
      return;
    }
    state.bridge.initMouseData();
  },
  getElectricity({ state }) {
    console.log("Bridge", "getElectricity");
    if (!state.bridge) return;
    state.bridge.getElectricity();
  },
  mouseReset({ state }) {
    console.log("Bridge", "mouseReset");
    if (!state.bridge) return;
    state.bridge.resetMouse();
  },
  changeMouseKey({ state }, json) {
    console.log("Bridge", "changeMouseKey", json);
    if (!state.bridge) return;
    state.bridge.changeMouseKey(JSON.stringify(json));
  },
  getMouseDPI({ state }) {
    console.log("Bridge", "getMouseDPI");
    if (!state.bridge) return;
    state.bridge.getMouseDPI();
  },
  setMouseDPI({ state }, json) {
    console.log("Bridge", "setMouseDPI", json);
    if (!state.bridge) return;
    state.bridge.setMouseDPI(JSON.stringify(json));
  },
  setMouseDPIButton({ state }, json) {
    console.log("Bridge", "setDPIButton", json);
    if (!state.bridge) return;
    state.bridge.setDPIButton(JSON.stringify(json));
  },
  getMouseDPIButton({ state }) {
    console.log("Bridge", "getDPIButton");
    if (!state.bridge) return;
    state.bridge.getDPIButton();
  },
  getFPS({ state }) {
    console.log("Bridge", "getFPS");
    if (!state.bridge) return;
    state.bridge.getFPS();
  },
  setFPS({ state }, json) {
    console.log("Bridge", "setFPS", json);
    if (!state.bridge) return;
    state.bridge.setFPS(JSON.stringify(json));
  },
  getMouseInfo({ state }) {
    console.log("Bridge", "getMouseInfo");
    if (!state.bridge) return;
    state.bridge.getMouseInfo();
  },
  getAM30ProfileKeySwitch({ state }) {
    console.log("Bridge", "getAM30ProfileKeySwitch");
    if (!state.bridge) return;
    state.bridge.getAM30ProfileKeySwitch();
  },
  setMouseProfile({ state }, json) {
    console.log("Bridge", "setMouseProfile", json);
    if (!state.bridge) return;
    state.bridge.setMouseProfile(JSON.stringify(json));
  },
  setSNEDORAngle({ state }, json) {
    console.log("Bridge", "setMouseSnedorAngle", json);
    if (!state.bridge) return;
    state.bridge.setMouseSnedorAngle(JSON.stringify(json));
  },
  setMouseInfo({ state }, json) {
    console.log("Bridge", "setMouseInfo", json);
    if (!state.bridge) return;
    state.bridge.setMouseInfo(JSON.stringify(json));
  },
  setAM30ProfileKeySwitch({ state }, json) {
    console.log("Bridge", "setAM30ProfileKeySwitch", json);
    if (!state.bridge) return;
    state.bridge.setAM30ProfileKeySwitch(JSON.stringify(json));
  },
  getMouseMacro({ state }) {
    console.log("Bridge", "getMouseMacro");
    if (!state.bridge) return;
    state.bridge.getMouseMacro();
  },
  saveMouseMacro({ state }, json) {
    console.log("Bridge", "saveMouseMacro", json);
    if (!state.bridge) return;
    state.bridge.saveMouseMacro(JSON.stringify(json));
  },
  deleteMouseMacro({ state }, json) {
    console.log("Bridge", "deleteMouseMacro", json);
    if (!state.bridge) return;
    state.bridge.deleteMouseMacro(JSON.stringify(json));
  },
  setMouseMacro({ state }, json) {
    console.log("Bridge", "setMouseMacro", json);
    if (!state.bridge) return;
    state.bridge.setMouseMacro(JSON.stringify(json));
  },
  resetMagnetKey({ state }) {
    console.log("Bridge", "resetMagnetKey");
    if (!state.bridge) return;
    state.bridge.resetMagnetKey();
  },
  getMouseSet({ state }, layer) {
    console.log("Bridge", "getMouseSet", layer);
    if (!state.bridge) return;
    state.bridge.getMouseSet(layer);
  },
  autoMouseUpdate({ state }, type) {
    console.log("Bridge", "autoMouseUpdate", type);
    if (!state.bridge) return;
    state.bridge.autoMouseUpdate(JSON.stringify({ up_type: type }));
  },
  localMouseUpdate({ state }, type) {
    console.log("Bridge", "localMouseUpdate", type);
    if (!state.bridge) return;
    state.bridge.localMouseUpdate(JSON.stringify({ up_type: type }));
  },
  getCurrentVer({ state }) {
    console.log("Bridge", "getCurrentVer");
    if (!state.bridge) {
      return;
    }
    state.bridge.getCurrentVer();
  },
  clearBlue({ state }) {
    console.log("Bridge", "clearBlue");
    if (!state.bridge) return;
    state.bridge.clearBlue();
  },
  loadMousejson({ state }) {
    console.log("Bridge", "loadMousejson");
    if (!state.bridge) return;
    state.bridge.loadMousejson();
  },
  saveMousejson({ state }, json) {
    console.log("Bridge", "saveMousejson", json);
    if (!state.bridge) return;
    state.bridge.saveMousejson(JSON.stringify(json));
  },
  getMDLight({ state }) {
    console.log("Bridge", "getMDLight");
    if (!state.bridge) return;
    state.bridge.getMDLight();
  },
  setMDLight({ state }, json) {
    console.log("Bridge", "setMDLight", json);
    if (!state.bridge) return;
    state.bridge.setMDLight(JSON.stringify(json));
  },
  getKeyLight({ state }, json) {
    console.log("Bridge", "getKeyLight", json);
    if (!state.bridge) return;
    state.bridge.getKeyLight(JSON.stringify(json));
  },
  sendKeyLight({ state }, json) {
    console.log("Bridge", "sendKeyLight", json);
    if (!state.bridge) return;
    state.bridge.sendKeyLight(JSON.stringify(json));
  },
  getKeySystem({ state }, json) {
    console.log("Bridge", "getSys", json);
    if (!state.bridge) return;
    state.bridge.getSys(JSON.stringify(json));
  },
  setKeySystem({ state }, json) {
    console.log("Bridge", "setSys", json);
    if (!state.bridge) return;
    state.bridge.setSys(JSON.stringify(json));
  },

  // AM Infinity .97
  initAM35Data({ state }) {
    console.log("Bridge", "getAM35AllData");
    if (!state.bridge) return;
    state.bridge.getAM35AllData();
  },
  getAM35Version({ state }) {
    console.log("Bridge", "getAM35Version");
    if (!state.bridge) return;
    state.bridge.getAM35Version();
  },
  getAM35Battery({ state }) {
    console.log("Bridge", "getAM35Battery");
    if (!state.bridge) return;
    state.bridge.getAM35Battery();
  },
  autoAM35update({ state }, type) {
    console.log("Bridge", "autoAM35update", type);
    if (!state.bridge) return;
    state.bridge.autoAM35update(JSON.stringify({ updateType: type }));
  },
  handleAM35update({ state }, type) {
    console.log("Bridge", "handleAM35update", type);
    if (!state.bridge) return;
    state.bridge.handleAM35update(JSON.stringify({ updateType: type }));
  },
  checkDeviceStatus({ state }) {
    console.log("Bridge", "checkDeviceStatus");
    if (!state.bridge) return;
    state.bridge.checkDeviceStatus();
  },
  resetAM35({ state }) {
    console.log("Bridge", "resetAM35");
    if (!state.bridge) return;
    state.bridge.resetAM35();
  },
  setAM35Profile({ state }, json) {
    console.log("Bridge", "setAM35Profile", json);
    if (!state.bridge) return;
    state.bridge.setAM35Profile(JSON.stringify(json));
  },
  getAM35ProfileKeySwitch({ state }) {
    console.log("Bridge", "getAM35ProfileKeySwitch");
    if (!state.bridge) return;
    state.bridge.getAM35ProfileKeySwitch();
  },
  setAM35ProfileKeySwitch({ state }, json) {
    console.log("Bridge", "setAM35ProfileKeySwitch", json);
    if (!state.bridge) return;
    state.bridge.setAM35ProfileKeySwitch(JSON.stringify(json));
  },
  loadAM35json({ state }) {
    console.log("Bridge", "loadAM35json");
    if (!state.bridge) return;
    state.bridge.loadAM35json();
  },
  saveAM35json({ state }, json) {
    console.log("Bridge", "saveAM35json", json);
    if (!state.bridge) return;
    state.bridge.saveAM35json(JSON.stringify(json));
  },
  setAM35DPI({ state }, json) {
    console.log("Bridge", "setAM35DPI", json);
    if (!state.bridge) return;
    state.bridge.setAM35DPI(JSON.stringify(json));
  },
  setAM35DPIButton({ state }, json) {
    console.log("Bridge", "setAM35DPIButton", json);
    if (!state.bridge) return;
    state.bridge.setAM35DPIButton(JSON.stringify(json));
  },
  setAM35DPIStages({ state }, json) {
    console.log("Bridge", "setAM35DPIStages", json);
    if (!state.bridge) return;
    state.bridge.setAM35DPIStages(JSON.stringify(json));
  },
  setAM35reportRate({ state }, json) {
    console.log("Bridge", "setAM35reportRate", json);
    if (!state.bridge) return;
    state.bridge.setAM35reportRate(JSON.stringify(json));
  },
  setAM35Debounce({ state }, json) {
    console.log("Bridge", "setAM35Debounce", json);
    if (!state.bridge) return;
    state.bridge.setAM35Debounce(JSON.stringify(json));
  },
  setAM35MotionSync({ state }, json) {
    console.log("Bridge", "setAM35MotionSync", json);
    if (!state.bridge) return;
    state.bridge.setAM35MotionSync(JSON.stringify(json));
  },
  setAM35LOD({ state }, json) {
    console.log("Bridge", "setAM35LOD", json);
    if (!state.bridge) return;
    state.bridge.setAM35LOD(JSON.stringify(json));
  },
  setAM35AngleSnapping({ state }, json) {
    console.log("Bridge", "setAM35AngleSnapping", json);
    if (!state.bridge) return;
    state.bridge.setAM35AngleSnapping(JSON.stringify(json));
  },
  setAM35RippleCtrl({ state }, json) {
    console.log("Bridge", "setAM35RippleCtrl", json);
    if (!state.bridge) return;
    state.bridge.setAM35RippleCtrl(JSON.stringify(json));
  },
  setAM35FPS({ state }, json) {
    console.log("Bridge", "setAM35FPS", json);
    if (!state.bridge) return;
    state.bridge.setAM35FPS(JSON.stringify(json));
  },
  setAM35rotateAngle({ state }, json) {
    console.log("Bridge", "setAM35rotateAngle", json);
    if (!state.bridge) return;
    state.bridge.setAM35rotateAngle(JSON.stringify(json));
  },
  setSleepTime({ state }, json) {
    console.log("Bridge", "setSleepTime", json);
    if (!state.bridge) return;
    state.bridge.setSleepTime(JSON.stringify(json));
  },
  changeAM35MouseKey({ state }, json) {
    console.log("Bridge", "changeAM35MouseKey", json);
    if (!state.bridge) return;
    state.bridge.changeAM35MouseKey(JSON.stringify(json));
  },
  setAM35light({ state }, json) {
    let dataToSend = json;
    if (json.mouseLightSwitch !== undefined) {
      dataToSend = {
        mouseLightSwitch: json.mouseLightSwitch,
        mouseLightType: json.mouseLightType,
        mouseLightSpeed: json.mouseLightSpeed,
      };
    }
    console.log("Bridge", "setAM35light", dataToSend);
    if (!state.bridge) return;
    state.bridge.setAM35light(JSON.stringify(dataToSend));
  },
  setAM35lightRGB({ state }, json) {
    let dataToSend = json;
    if (json.mouseLightRGB !== undefined) {
      dataToSend = {
        mouseLightRGB: json.mouseLightRGB,
      };
    }
    console.log("Bridge", "setAM35lightRGB", dataToSend);
    if (!state.bridge) return;
    state.bridge.setAM35lightRGB(JSON.stringify(dataToSend));
  },
  setAM35Dlight({ state }, json) {
    let dataToSend = json;
    if (json.dongleLightSwitch !== undefined) {
      // 创建基础对象，包含非数字属性
      dataToSend = {
        dongleLightSwitch: json.dongleLightSwitch,
        dongleLightType: json.dongleLightType,
        dongleColor: json.dongleColor,
        dongleColor2: json.dongleColor2,
        dongleColor3: json.dongleColor3,
      };
      // 仅当数字属性非 null 且非 undefined 时才添加，并转换为数字类型
      if (json.dongleSaturationPer != null) {
        dataToSend.dongleSaturationPer = Number(json.dongleSaturationPer);
      }

      if (json.dongleSaturationPer2 != null) {
        dataToSend.dongleSaturationPer2 = Number(json.dongleSaturationPer2);
      }

      if (json.dongleSaturationPer3 != null) {
        dataToSend.dongleSaturationPer3 = Number(json.dongleSaturationPer3);
      }

      if (json.dongleSpeed != null) {
        dataToSend.dongleSpeed = Number(json.dongleSpeed);
      }

      if (json.dongleBrightness != null) {
        dataToSend.dongleBrightness = Number(json.dongleBrightness);
      }
    }
    console.log("Bridge", "setAM35Dlight", dataToSend);
    if (!state.bridge) return;
    state.bridge.setAM35Dlight(JSON.stringify(dataToSend));
  },
  saveAM35macro({ state }, json) {
    console.log("Bridge", "saveAM35macro", json);
    if (!state.bridge) return;
    state.bridge.saveAM35macro(JSON.stringify(json));
  },
};

const mutations = {
  SET_LOADING: (state, loading) => {
    state.loading = loading;
  },
  SET_IN_LOADER: (state, inLoader) => {
    state.inLoader = inLoader;
  },
  SET_IS_WEB: (state, data) => {
    state.isWeb = data;
  },
  SET_BRIDGE: (state, bridge) => {
    state.bridge = bridge;
  },
  SET_DEVICE_NAME: (state, deviceName) => {
    state.deviceName = deviceName;
  },
  SET_LOADER_INFO: (state, systemInfo) => {
    state.systemInfo = systemInfo;
  },
  SET_CURRENT_DEVICE: (state, device) => {
    state.currentDevice = device;
  },
  SET_ACTIVE_DEVICE_INDEX: (state, index) => {
    state.activeDeviceIndex = index;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
